export async function getHubMessages(request: any, service: Xplor.Service) {
  const response = await request.get(`/api/parent/messages/${service.id}`)
  const data = response && response.data

  // use-http returns the previous response after a failed fetch, so keep only items that have an id.
  return Array.isArray(data) ? data.filter(({ id }) => id != null) : []
}
